const MergeTagChip = ({ mergeTag }: { mergeTag: string }) => {
  return (
    <span
      style={{
        background: `rgb(175, 191, 176)`,
        borderRadius: "0.4rem",
        boxDecorationBreak: "clone",
        padding: "0.2rem 0.3rem",
      }}
    >
      {mergeTag}
    </span>
  );
};

export default MergeTagChip;
